// Global Instructions Rule Applied!
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Result, Button } from 'antd'
import { MOBILE_ROUTES } from '../lib/routes.ts'

/**
 * Catch-all for any route the mobile companion doesn't cover (lists, pipeline,
 * reports, create/edit forms). Read-only mobile is search + the four record views;
 * everything else points the user back to the full desktop app.
 */
export function DesktopOnlyNotice(): React.JSX.Element {
  const navigate = useNavigate()
  return (
    <div style={{ padding: '24px 16px' }}>
      <Result
        status="info"
        title="Best on desktop"
        subTitle="This view isn't available on the mobile companion. Open Reservoir on your computer for lists, reports, and editing. On your phone you can search and view companies, deals, contacts, and funds."
        extra={
          <Button type="primary" onClick={() => navigate(MOBILE_ROUTES.search)}>
            Go to search
          </Button>
        }
      />
    </div>
  )
}

export default DesktopOnlyNotice
